import api from "./Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Admin Login
export const adminLogin = async ({ username, password }) => {
  const formData = new FormData();

  formData.append("username", String(username || "").trim());
  formData.append("password", String(password || ""));

  const response = await api.post("/admin/dashboard/login", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData (Axios هيظبطه)
    },
    params: {
      api_password: "AI_Pos_passCode2026",
    },
  });

  // ✅ لو الـ API بيرجع token زي اللي في الصورة، خزّنه
  const token = response?.data?.data?.token;
  if (token) {
    localStorage.setItem("token", token);
  }

  return response;
};
// ✅ User Login
// export const userLogin = async (phone, password) => {
//   const headers = {
//     Accept: "application/json",
//   };

//   const formData = new FormData();
//   formData.append("phone", phone);
//   formData.append("password", password);

//   try {
//     const res = await api.post("/user/login", formData, {
//       headers,
//       params: {
//         api_password: "AI_Pos_passCode2026",
//       },
//     });

//     return res.data;
//     /*
//       expected (غالباً):
//       {
//         token: "...",
//         data: { user... },
//         message: "..."
//       }
//     */
//   } catch (error) {
//     const serverData = error?.response?.data;
//     if (serverData?.message) throw new Error(serverData.message);
//     throw error;
//   }
// };
export const userLogin = async ({ phone, password }) => {
  const formData = new FormData();

  formData.append("phone", String(phone || "").trim());
  formData.append("password", String(password || ""));

  const response = await api.post("/user/login", formData, {
    headers: {
      Accept: "application/json",
      // ❌ متحطش Content-Type مع FormData (Axios هيظبطه)
    },
    params: {
      api_password: "AI_Pos_passCode2026",
    },
  });

  // ✅ لو الـ API بيرجع token زي اللي في الصورة، خزّنه
  const token = response?.data?.token;
  if (token) {
    localStorage.setItem("token", token);
  }

  return response.data;
};
// ✅ Logout
export const logoutUser = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/logout", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    // مسح التوكن بعد نجاح الطلب
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");

    return res.data;
    /*
      expected:
      {
        data: [],
        message: "تم تسجيل الخروج"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
